<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingMyPaymentsInvoiceHistory"
  >

    <div class="align-items-baseline display-flex-row m-filters-and-actions">
      <form
        autocomplete="off"
        class="align-items-baseline m-form-row m-simple-filter"
        name="simple-filters-form"
        @submit.prevent="searchSimpleFilter"
      >
        <AtomSelectPrimary
          v-model.number="simpleFilter.estado"
          :disabled="pagination.showLoadingState"
          :elements="$filters.parameters.paymentsStates"
          keyField="id"
          name="estado"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />

        <AtomSelectPrimary
          v-model.number="simpleFilter.periodo"
          :disabled="pagination.showLoadingState"
          :elements="$filters.parameters.periods"
          keyField="id"
          name="periodo"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />

        <AtomButtonSecondary
          :button-secondary="buttonSecondary.reset"
          :disabled="pagination.showLoadingState"
          @reloadListing="reloadListing"
        />
      </form>

      <div class="m-dropdown-primary">
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.filter"
          :disabled="pagination.showLoadingState"
          @switchDropDown="$dropDown.switchDropDown"
        />
        <MoleculeEditionBillingMyPaymentsDropDownFilters
          :filter-seted="filter"
          @reloadListing="reloadListing"
          @searchAdvancedFilter="searchAdvancedFilter"
        />
      </div>

      <form
        autocomplete="off"
        class="m-form-row margin-left-auto"
        name="download-csv-form"
        @submit.prevent="readPagosExportar"
      >
        <AtomButtonPrimary
          :button-primary="buttonPrimary"
          :disabled="pagination.showLoadingState || !pagos.length"
        />
      </form>
    </div>

    <div class="m-table-primary">
      <table class="table-layout-fixed">
        <tr v-show="pagos.length">
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionBillingMyPaymentsInvoiceHistory.table.thDate') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionBillingMyPaymentsInvoiceHistory.table.thAmount') }}
          </th>
          <th
            class="text-align-center"
            width="9%"
          >
            {{ $t('mEditionBillingMyPaymentsInvoiceHistory.table.thTax') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionBillingMyPaymentsInvoiceHistory.table.thDiscount') }}
          </th>
          <th
            class="text-align-center"
            width="14%"
          >
            {{ $t('mEditionBillingMyPaymentsInvoiceHistory.table.thMethod') }}
          </th>
          <th
            class="text-align-left"
            width="17%"
          >
            {{ $t('mEditionBillingMyPaymentsInvoiceHistory.table.thDetail') }}
          </th>
          <th
            class="text-align-center"
            width="13%"
          >
            {{ $t('mEditionBillingMyPaymentsInvoiceHistory.table.thToPay') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionBillingMyPaymentsInvoiceHistory.table.thInvoice') }}
          </th>
        </tr>
        <tr
          v-for="(pago, index) in pagos"
          :key="index"
          class="row-data"
        >
          <td class="text-align-center text-white-space-nowrap">
            {{ paymentDate(pago) }}
          </td>
          <td class="text-align-center text-white-space-nowrap">
            <a
              class="sale-state"
              href="#"
              @click.prevent="gotToInvoice(pago)"
            >
              <span>{{ pago.divisa_simbolo }} {{ pago.monto.toFixed(2) }}</span>
              <span class="text-color-black-35"> {{ pago.divisa }}</span><br>
              <small :class="$filters.getPaymentStateValue(pago.pago_estado, 'class')">
                {{ $filters.getPaymentStateValue(pago.pago_estado, 'name') }}
              </small>
            </a>
          </td>
          <td class="text-align-center">
            <span class="text-color-black-35">{{ `(${pago.tipo_impuesto})` }}</span> {{ pago.impuesto }}%
          </td>
          <td class="ellipsis text-align-center">
            <span
              v-if="pago.cupon_codigo"
              :key="`${index}-${pago.cupon_codigo}`"
            >
              {{ pago.cupon_codigo }}
            </span>
            <span
              v-else
              :key="`${index}-nodiscount`"
            >
              -
            </span>
          </td>
          <td class="text-align-center">
            {{ pago.medio_pago }}
          </td>
          <td class="break-word text-align-left">
            {{ pago.concepto }}
          </td>
          <td class="text-align-center">
            {{ $utils.getPaymentFrequency(pago.plan_cuotas, pago.plan_frecuencia, pago.plan_intervalo) }}
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.record"
              :element="pago"
              @gotToInvoice="gotToInvoice(pago)"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMyPaymentsInvoiceHistory',

  components: {
    MoleculeEditionBillingMyPaymentsDropDownFilters: () => import('@/components/molecules/MoleculeEditionBillingMyPaymentsDropDownFilters'),
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      buttonIconRounded: {
        record: {
          class: 'a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'far fa-file-alt',
          method: 'gotToInvoice',
          tooltip: this.$t('mEditionBillingMyPaymentsInvoiceHistory.tooltips.invoice'),
          type: 'button'
        }
      },

      buttonPrimary: {
        action: this.$t('mEditionBillingMyPaymentsInvoiceHistory.buttonPrimary'),
        behavior: 'download',
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        filter: {
          class: 'a-button-billing-secondary a-button-side',
          component: 'MoleculeEditionBillingMyPaymentsDropDownFilters',
          icon: 'fas fa-filter',
          method: 'switchDropDown',
          text: this.$t('mEditionBillingMyPaymentsInvoiceHistory.buttonSecondary.filterText'),
          type: 'button'
        },

        reset: {
          class: 'a-button-billing-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-sync-alt',
          method: 'reloadListing',
          text: '',
          tooltip: this.$t('mEditionBillingMySales.tooltip.restart'),
          type: 'button'
        }
      },

      filter: {
        estado: [],
        divisa: [],
        pasarela_pago: [],
        fecha_desde: '',
        fecha_hasta: '',
        cupon: '',
        pagina: 1,
        limite: 10
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      },

      pagos: [],
      showLoadingState: true,

      simpleFilter: {
        estado: '',
        periodo: 0
      }
    }
  },

  watch: {
  },

  created () {
    this.readVentasMisPagos()
  },

  methods: {
    gotToInvoice (pago) {
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.myPayments.subject')}/${pago.id_pago}/${this.$t('mEditionMenu.billing.myPayments.children.invoice.subedition')}`)
    },

    paymentDate (pago) {
      if (pago.pago_estado === 0) {
        return this.$moment.parseZone(pago.fecha_pago_vencimiento).subtract(5, 'days').format('D MMM YYYY')
      } else if (pago.pago_estado === 2) {
        return this.$moment.parseZone(pago.fecha_pago).format('D MMM YYYY')
      } else {
        return this.$moment.parseZone(pago.fecha_estado).format('D MMM YYYY')
      }
    },

    readVentasMisPagos () {
      if (!this.pagination.showLoadingState) {
        this.pagination.showLoadingState = true
        this.$services.read('ventas', 'readVentasMisPagos', {}, [this.$store.getters.getAcademyData.id], this.filter)
          .then(response => {
            this.pagos = []
            this.pagos = response.data.pagos
            this.pagination.currentQuantity = this.pagos.length
            this.pagination.totalPages = response.data.pages
            this.pagination.totalQuantity = response.data.total
            this.pagination.showLoadingState = false
            this.showLoadingState = false
          })
          .catch(error => {
            console.log(error)
            this.pagos = []
            this.pagination.currentQuantity = 0
            this.pagination.totalPages = 0
            this.pagination.totalQuantity = 0
            this.pagination.showLoadingState = false
            this.showLoadingState = false
          })
      }
    },

    readPagosExportar () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.read('ventas', 'readVentasMisPagosExportar', {}, [this.$store.getters.getAcademyData.id], this.filter)
          .then(response => {
            this.$files.downloadCsv(response.data, `${this.$t('mEditionBillingMyPaymentsInvoiceHistory.files.sales')}-${this.$moment().format('YYYYMMDD')}`)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionBillingMyPaymentsInvoiceHistory', 'readPagosExportar', 'success')
          })
          .catch(error => {
            console.log(error)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionBillingMyPaymentsInvoiceHistory', 'readPagosExportar', 'error', 'a-alert-danger')
          })
      }
    },

    reloadListing () {
      this.resetSimpleFilter()
      this.resetAdvancedFilter()
      this.setPaginationCurrentPage(1)
    },

    resetAdvancedFilter () {
      this.filter = {
        estado: [],
        divisa: [],
        pasarela_pago: [],
        fecha_desde: '',
        fecha_hasta: '',
        cupon: '',
        pagina: 1,
        limite: 10
      }
    },

    resetSimpleFilter () {
      this.simpleFilter = {
        estado: '',
        periodo: 0
      }
    },

    searchAdvancedFilter (advancedFilter) {
      this.resetSimpleFilter()
      this.filter = Object.assign({}, advancedFilter)
      this.setPaginationCurrentPage(1)
    },

    searchSimpleFilter () {
      this.resetAdvancedFilter()

      if (this.simpleFilter.estado !== '') {
        this.filter.estado[0] = this.simpleFilter.estado
      }

      if (this.simpleFilter.periodo === '') {
        this.simpleFilter.periodo = 0
      }

      this.filter.fecha_desde = this.$filters.parameters.periods[this.simpleFilter.periodo].dateFrom
      this.filter.fecha_hasta = this.$filters.parameters.periods[this.simpleFilter.periodo].dateTo
      this.setPaginationCurrentPage(1)
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readVentasMisPagos()
    }
  }
}
</script>
